/**
 * Create RAC Agreement Module — AJAX Form Handler
 *
 * Handles the #create-rac-agreement-form submit:
 *  1. Client-side validation of required fields.
 *  2. jQuery UI Autocomplete for variety and merchant name inputs,
 *     sourced from bipoRacData (passed via wp_localize_script).
 *  3. AJAX POST to wp_ajax_nopriv_bipo_create_rac.
 *  4. Duplicate-email detection: renders an inline confirmation dialog
 *     (not jQuery UI Dialog — a custom lightweight overlay) and re-submits
 *     with the email_dupe_confirmed flag when the user clicks Continue.
 *  5. On success: hides the form and shows a confirmation message.
 *  6. On error: shows a banner above the form.
 *
 * Dependencies: jQuery, jQuery UI Autocomplete (loaded via wp_enqueue_script).
 * bipoRacData is localised by bipo_enqueue_create_rac_script() in functions.php.
 */
(function ($) {
	'use strict';

	$(document).ready(function () {

		var $form = $('#create-rac-agreement-form');

		if (!$form.length) {
			return;
		}

		var ajaxUrl = $form.data('ajax-url');
		var restUrl = $form.data('rest-url');
		var nonce   = $form.data('nonce');

		// ── Autocomplete setup ────────────────────────────────────────────────

		/**
		 * Initialise jQuery UI Autocomplete on a name input backed by a hidden
		 * code field. Selecting a suggestion writes its label to the name input
		 * and its value to the code input.
		 *
		 * @param {string} nameInputId  - ID of the visible text input.
		 * @param {string} codeInputId  - ID of the hidden code input.
		 * @param {Array}  data         - [{label, value}] array from bipoRacData.
		 */
		function initAutocomplete(nameInputId, codeInputId, data) {
			if (!data || !data.length) {
				return;
			}

			$('#' + nameInputId).autocomplete({
				source: data,
				focus : function (event, ui) {
					event.preventDefault();
					$(this).val(ui.item.label);
				},
				select: function (event, ui) {
					event.preventDefault();
					$(this).val(ui.item.label);
					$('#' + codeInputId).val(ui.item.value);
				},
				change: function (_event, ui) {
					if (!ui.item) {
						$('#' + codeInputId).val('');
					}
				},
				search: function () {
					$('#' + codeInputId).val('');
				},
			});
		}

		if (typeof bipoRacData !== 'undefined') {
			initAutocomplete('rac-variety-1', 'rac-variety-1-code', bipoRacData.varieties);
			initAutocomplete('rac-variety-2', 'rac-variety-2-code', bipoRacData.varieties);
			initAutocomplete('rac-merchant',  'rac-merchant-code',  bipoRacData.merchants);
		}

		// ── Form submission ───────────────────────────────────────────────────

		$form.on('submit', function (e) {
			e.preventDefault();
			submitForm(false);
		});

		/**
		 * Collect form data, validate, and POST to the AJAX endpoint.
		 *
		 * @param {boolean} dupeConfirmed - True when user has acknowledged the
		 *                                  duplicate-email dialog and wants to proceed.
		 */
		function submitForm(dupeConfirmed) {
			clearErrors();
			hideResponse();

			if (!validateForm()) {
				return;
			}

			setSubmitting(true);

			// Fetch a fresh nonce to survive page caching, then POST the form.
			$.getJSON( restUrl + 'bipo/v1/nonce/bipo_create_rac_nonce' )
				.always( function ( data ) {
					if ( data && data.nonce ) {
						nonce = data.nonce;
					}

					var formData = collectFormData();
					formData.email_dupe_confirmed = dupeConfirmed ? '1' : '0';

					$.ajax({
						url    : ajaxUrl,
						type   : 'POST',
						data   : formData,
						success: function (response) {
							setSubmitting(false);

							if (response.success) {
								if (response.data.duplicate_email) {
									// Duplicate email: show confirmation dialog
									showDupeDialog(response.data.message, function () {
										submitForm(true);
									});
								} else {
									showSuccess(response.data);
								}
							} else {
								showError(response.data.message || 'An unexpected error occurred. Please try again.');
							}
						},
						error: function () {
							setSubmitting(false);
							showError('An unexpected error occurred. Please try again.');
						},
					});
				});
		}

		// ── Validation ────────────────────────────────────────────────────────

		/**
		 * Validate all required fields and show inline errors.
		 *
		 * @return {boolean} True if the form is valid.
		 */
		function validateForm() {
			var valid = true;

			valid = requireField('rac-company-name', 'rac-company-name-error',  'Please enter business name.')       && valid;
			valid = requireField('rac-first-name',   'rac-first-name-error',    'Please enter first name.')          && valid;
			valid = requireField('rac-last-name',    'rac-last-name-error',     'Please enter last name.')           && valid;
			valid = requireEmail('rac-email',        'rac-email-error')                                              && valid;
			valid = requireField('rac-address-1',    'rac-address-error',       'Please enter business address.')    && valid;
			valid = requireField('rac-county',       'rac-county-error',        'Please enter county.')              && valid;
			valid = requirePostcode('rac-postcode',   'rac-postcode-error')                                        && valid;
			valid = requireField('rac-variety-1',    'rac-variety-1-error',     'Please enter at least one variety.') && valid;
			valid = requireCheckbox('rac-accept-terms', 'rac-terms-error', 'Please accept the terms & conditions.') && valid;

			return valid;
		}

		/**
		 * Mark a text input as required — invalid if empty.
		 *
		 * @param  {string}  inputId  - Input element ID.
		 * @param  {string}  errorId  - Error span ID.
		 * @param  {string}  message  - Error text.
		 * @return {boolean}
		 */
		function requireField(inputId, errorId, message) {
			var val = $('#' + inputId).val().trim();
			if (!val) {
				showFieldError(inputId, errorId, message);
				return false;
			}
			return true;
		}

		/**
		 * Validate email format.
		 *
		 * @param  {string}  inputId - Input element ID.
		 * @param  {string}  errorId - Error span ID.
		 * @return {boolean}
		 */
		function requireEmail(inputId, errorId) {
			var val = $('#' + inputId).val().trim();
			if (!val) {
				showFieldError(inputId, errorId, 'Please enter email address.');
				return false;
			}
			if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
				showFieldError(inputId, errorId, 'Please enter a valid email address.');
				return false;
			}
			return true;
		}

		/**
		 * Validate postcode is present and correctly formatted.
		 *
		 * @param  {string}  inputId - Input element ID.
		 * @param  {string}  errorId - Error span ID.
		 * @return {boolean}
		 */
		function requirePostcode(inputId, errorId) {
			var val = $('#' + inputId).val().trim();
			if (!val) {
				showFieldError(inputId, errorId, 'Please enter postcode.');
				return false;
			}
			if (!isValidPostcode(val)) {
				showFieldError(inputId, errorId, 'Enter valid postcode with space (e.g. SW1A 1AA).');
				return false;
			}
			return true;
		}

		/**
		 * Validate a checkbox is checked.
		 *
		 * @param  {string}  inputId - Checkbox element ID.
		 * @param  {string}  errorId - Error span ID.
		 * @param  {string}  message - Error text.
		 * @return {boolean}
		 */
		function requireCheckbox(inputId, errorId, message) {
			if (!$('#' + inputId).prop('checked')) {
				$('#' + errorId).text(message).removeAttr('hidden');
				return false;
			}
			return true;
		}

		/**
		 * Show an error on a specific field.
		 *
		 * @param {string} inputId - Input element ID to highlight.
		 * @param {string} errorId - Error span ID.
		 * @param {string} message - Error text.
		 */
		function showFieldError(inputId, errorId, message) {
			$('#' + errorId).text(message).removeAttr('hidden');
			$('#' + inputId).addClass('is-invalid');
		}

		/**
		 * Clear all field errors and invalid states.
		 */
		function clearErrors() {
			$('.create-rac-agreement__error').text('').attr('hidden', '');
			$('.create-rac-agreement__input').removeClass('is-invalid');
			$('.create-rac-agreement__checkbox').removeClass('is-invalid');
		}

		// ── Data collection ───────────────────────────────────────────────────

		/**
		 * Collect serialised form data plus the AJAX action and nonce.
		 *
		 * @return {Object} Plain object of form field values.
		 */
		function collectFormData() {
			var data = {
				action: 'bipo_create_rac',
				nonce : nonce,
			};

			$form.find('input, textarea, select').each(function () {
				var $el  = $(this);
				var name = $el.attr('name');
				if (!name) {
					return;
				}
				if ($el.attr('type') === 'checkbox') {
					data[name] = $el.prop('checked') ? '1' : '0';
				} else {
					data[name] = $el.val();
				}
			});

			return data;
		}

		// ── UI state helpers ──────────────────────────────────────────────────

		/**
		 * Toggle the submit button disabled state and label.
		 *
		 * @param {boolean} isSubmitting
		 */
		function setSubmitting(isSubmitting) {
			var $btn = $('#rac-submit-btn');
			$btn.prop('disabled', isSubmitting);
			$btn.text(isSubmitting ? 'Submitting, please wait…' : 'Submit');
		}

		/**
		 * Show a structured success message and hide the form.
		 * Displays the server message, submitted business name, and assigned member ID.
		 *
		 * @param {Object} data - response.data from the AJAX response.
		 * @param {string} data.message   - Server confirmation text.
		 * @param {string} data.member_id - Assigned RAC member number.
		 */
		function showSuccess(data) {
			var businessName = $('#rac-company-name').val().trim();
			var html = '<div class="create-rac-agreement__response-success">';
			html += '<p>' + escapeHtml(data.message || 'Your application has been submitted successfully.') + '</p>';
			if (businessName) {
				html += '<p>Business name: ' + escapeHtml(businessName) + '</p>';
			}
			if (data.member_id) {
				html += '<p>RAC Member: ' + escapeHtml(data.member_id) + '</p>';
			}
			html += '</div>';
			$form.hide();
			$('#rac-response').removeAttr('hidden').html(html);
		}

		/**
		 * Show a global error banner above the form.
		 *
		 * @param {string} message
		 */
		function showError(message) {
			$('#rac-response')
				.removeAttr('hidden')
				.html('<div class="create-rac-agreement__response-error">' + escapeHtml(message) + '</div>');
		}

		/**
		 * Hide the response area.
		 */
		function hideResponse() {
			$('#rac-response').attr('hidden', '').empty();
		}

		// ── Duplicate email dialog ────────────────────────────────────────────

		/**
		 * Render a lightweight confirmation dialog for duplicate email detection.
		 * When the user clicks "Continue", invokes onConfirm and removes the overlay.
		 *
		 * @param {string}   message    - Dialog body text.
		 * @param {Function} onConfirm  - Callback when user confirms.
		 */
		function showDupeDialog(message, onConfirm) {
			removeDupeDialog();

			var $overlay = $('<div class="create-rac-agreement__dialog-overlay" id="rac-dupe-overlay"></div>');
			var $dialog  = $('<div class="create-rac-agreement__dialog" role="dialog" aria-modal="true" aria-label="Confirmation required"></div>');

			$dialog.append('<p>' + escapeHtml(message) + '</p>');

			var $actions = $('<div class="create-rac-agreement__dialog-actions"></div>');

			var $confirm = $('<button type="button" class="create-rac-agreement__dialog-confirm">Continue</button>');
			$confirm.on('click', function () {
				removeDupeDialog();
				onConfirm();
			});

			var $cancel = $('<button type="button" class="create-rac-agreement__dialog-cancel">Cancel</button>');
			$cancel.on('click', removeDupeDialog);

			$actions.append($confirm).append($cancel);
			$dialog.append($actions);
			$overlay.append($dialog);
			$('body').append($overlay);

			$confirm.trigger('focus');
		}

		/**
		 * Remove the duplicate email confirmation dialog overlay from the DOM.
		 */
		function removeDupeDialog() {
			$('#rac-dupe-overlay').remove();
		}

		// ── Utility ───────────────────────────────────────────────────────────

		/**
		 * Validate a UK postcode format — requires a space (e.g. "SW1A 1AA").
		 *
		 * @param  {string}  value - Postcode string to validate.
		 * @return {boolean}
		 */
		function isValidPostcode(value) {
			return /^[a-zA-Z]{1,2}\d[a-zA-Z0-9]?\s\d[a-zA-Z]{2}$/i.test(value);
		}

		/**
		 * Escape HTML special characters to prevent XSS when injecting content.
		 *
		 * @param  {string} str - Raw string.
		 * @return {string}     - HTML-safe string.
		 */
		function escapeHtml(str) {
			return String(str)
				.replace(/&/g,  '&amp;')
				.replace(/</g,  '&lt;')
				.replace(/>/g,  '&gt;')
				.replace(/"/g,  '&quot;')
				.replace(/'/g,  '&#039;');
		}

	});

}(jQuery));
